import { render, staticRenderFns } from "./IconOtherCommonBlack.vue?vue&type=template&id=7e96d25c"
import script from "./IconOtherCommonBlack.vue?vue&type=script&lang=js"
export * from "./IconOtherCommonBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports